import Swiper from 'swiper/js/swiper'

function headerCarousel() {
  function setSlider() {
    const slider = new Swiper('.js-header-slider', {
      loop: true,
      // autoplay: true,
      autoplay: {
        delay: 6000,
      },
      speed: 1000,
      // autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      slidesPerView: 1,
      roundLengths: true,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: '.c-header-slider-next',
        prevEl: '.c-header-slider-prev',
      },
    })
  }

  const isPresent = document.getElementsByClassName('c-header-slider-wrap')
  if (isPresent.length > 0) {
    setSlider()
  }
}

export { headerCarousel }

function imagesCarousel() {
  function setSlider() {
    const slider = new Swiper('.js-images-slider', {
      loop: true,
      autoplay: true,
      autoplay: {
        delay: 3000,
      },
      speed: 1000,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      slidesPerView: 1,
      roundLengths: true,
      keyboard: {
        enabled: true,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.c-images-slider-next',
        prevEl: '.c-images-slider-prev',
      },
    })
  }

  const isPresent = document.getElementsByClassName('c-images-slider')
  if (isPresent.length > 0) {
    setSlider()
  }
}

export { imagesCarousel }

function highlightsCarousel() {
  function setSlider() {
    const slider = new Swiper('.js-highlights-slider', {
      loop: true,
      autoplay: true,
      slidesPerView: 2,
      // centeredSlides: true,
      slidesPerGroup: 1,
      roundLengths: true,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        300: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 20,
        },
        600: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 20,
        },
        850: {
          slidesPerView: 4,
          slidesPerGroup: 1,
          spaceBetween: 20,
        },
        1100: {
          slidesPerView: 6,
          slidesPerGroup: 1,
          spaceBetween: 20,
        },
      },
    })
  }

  const isPresent = document.getElementsByClassName('c-highlights')
  if (isPresent.length > 0) {
    setSlider()
  }
}

export { highlightsCarousel }
